var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicronesia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#338AF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9986 6.95654L16.6892 9.08229H18.9244L17.1162 10.3961L17.8068 12.5218L15.9986 11.208L14.1903 12.5218L14.8811 10.3961L13.0728 9.08229H15.3079L15.9986 6.95654Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95581 16.0002L9.08156 15.3095V13.0742L10.3954 14.8826L12.5211 14.1919L11.2073 16.0002L12.5211 17.8083L10.3954 17.1176L9.08156 18.9259V16.6908L6.95581 16.0002Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 25.0435L15.308 22.9178H13.0728L14.8811 21.604L14.1904 19.4783L15.9987 20.792L17.8069 19.4783L17.1161 21.604L18.9244 22.9178H16.6893L15.9987 25.0435Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.043 16L22.9173 16.6907V18.9259L21.6035 17.1176L19.4778 17.8083L20.7915 16L19.4778 14.1918L21.6035 14.8826L22.9173 13.0742V15.3094L25.043 16Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicronesia);
export default __webpack_public_path__ + "static/media/micronesia.de00df19.svg";
export { ForwardRef as ReactComponent };